import { render, staticRenderFns } from "./textIcon-editor.vue?vue&type=template&id=1f18d994&scoped=true&"
import script from "./textIcon-editor.vue?vue&type=script&lang=js&"
export * from "./textIcon-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f18d994",
  null
  
)

export default component.exports